import {defineStore} from 'pinia'
import {useUserStore} from "@/stores/user";
import router from "@/router";
export const useAdsStore = defineStore('ads_store', {
    // a function that returns a fresh state
    state: () => ({
        items: [],
        loading: false,
    }),
    // optional getters
    getters: {
        getAdById: (state) => {
            return (adId) => state.items.find((ad) => ad.id === adId)
        },
    },
    // optional actions
    actions: {
        buildFormData(data) {
            const kdnr = useUserStore().user.organisation.kdnr;
            const formData = new FormData(); // pass data as a form
            formData.append('kdnr', kdnr);
            formData.append("ad[title]", data.ad.title)
            formData.append("ad[link]", data.ad.link)
            if(data.ad.file !== undefined) {
                formData.append("ad[file]", data.ad.file[0])
            }
            if(data.ad.content) {
                formData.append("ad[content]", data.ad.content)
            }
            if(data.ad.custom_color) {
                formData.append("ad[custom_color]", data.ad.custom_color)
            }
            if(data.ad.button_text) {
                formData.append("ad[button_text]", data.ad.button_text)
            }
            return formData
        },
        show(adId) {
            this.loading = true
            const kdnr = useUserStore().user.organisation.kdnr || router.currentRoute.value.query.kdnr;
            console.log(kdnr)
            return this.apiClient.get(`/ads/${adId}?kdnr=${kdnr}`)
        },
        index() {
            this.loading = true
            const kdnr = useUserStore().user.organisation.kdnr || router.currentRoute.value.query.kdnr;
            return this.apiClient.get(`/ads?kdnr=${kdnr}`).then(({data}) => {
                this.items = data
                this.loading = false
            })
        },
        create(data) {
            const formData = this.buildFormData(data)
            const conf = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            return this.apiClient.post(`/ads`, formData, conf)
        },
        update(id, data) {
            const formData = this.buildFormData(data)
            console.log(formData)
            const conf = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            return this.apiClient.put(`/ads/${id}`, formData, conf)
        },

    },
})
